import type { PostHogConfig } from 'posthog-js';
import { RouterProvider } from 'react-router-dom';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { PostHogProvider } from 'posthog-js/react';
import { Toaster } from 'sonner';

import { DeviceIdProvider } from './components/device-id-provider';
import { router } from './router';

const queryClient = new QueryClient();

const posthogConfig: Partial<PostHogConfig> = {
  name: 'Role play frontend app',
  opt_out_capturing_persistence_type: 'localStorage',
  api_host: import.meta.env.VITE_POSTHOG_HOST,
  debug: import.meta.env.DEV,
  disable_session_recording: !import.meta.env.PROD,
  opt_out_capturing_by_default: !import.meta.env.PROD,
};

export const App: React.FC = () => {
  return (
    <QueryClientProvider client={queryClient}>
      <PostHogProvider
        apiKey={import.meta.env.VITE_POSTHOG_KEY}
        options={posthogConfig}
      >
        <DeviceIdProvider>
          <RouterProvider router={router} />
          <Toaster
            invert
            theme="light"
            richColors
            position="top-center"
            toastOptions={{
              style: {
                borderRadius: '8px',
                padding: '12px',
                boxShadow: '0px 4px 8px rgba(0, 0, 0, 0.1)',
              },
            }}
          />
        </DeviceIdProvider>
      </PostHogProvider>
    </QueryClientProvider>
  );
};
